// extracted by mini-css-extract-plugin
module.exports = {"ButtonArea":"TodoTemplateList_ButtonArea__vUIWr"};